/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/risk-action.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const CMActionRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const lookups: any = {
        OwnerId: (action: any) => (action?.owner ? `${action.owner.firstName} ${action.owner.lastName}` : ' '),
        ResponsibleFunctionId: (observation: any) => observation?.responsibleFunction?.name ?? ' ',
    };
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              Deleted: oldRecord.D,
          }
        : null;
    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              Deleted: newRecord.D,
          }
        : null;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field, lookups }),
    );

    return <FieldChangeGrid items={items} />;
};

export { CMActionRecordChangeGrid };
